import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

// 获取推荐商品列表
export const getRecommendList = (params: object = {}) => $http.get('/relevance/relevance_goods_all_list', params)

// 添加推荐商品
export const addRecommendProduct = (product_ids: string) => $http.post('/relevance/relevance_goods_all_add', {product_ids})

// 删除推荐商品
export const delRecommendProduct = (del_ids: string) => $http.get('/relevance/relevance_goods_del', {del_ids})

// 获取被推荐品牌列表
export const getRecommendedBrandList = (params: object = {}) => $http.get('/relevance/relevance_brand_list', params)

// 添加被推荐品牌
export const addRecommendedBrand = (brand_ids: string) => $http.post('/relevance/relevance_brand_add', {brand_ids})

// 删除被推荐品牌
export const delRecommendedBrand = (brand_ids: number) => $http.post('/relevance/relevance_brand_del', {brand_ids})

// 获取被推荐指定品牌下指定商品的推荐配置
export const getRecommendedProductInfo = (product_id: any) => $http.get('/relevance/relevance_goods_details', {product_id})

// 保存被推荐指定品牌下指定商品的推荐配置
export const saveRecommendedProductInfo = (data: object) => $http.post('/relevance/relevance_goods_add', data)
